const contactData = {
  headline: "Igor Sonntag",
  subheading: "Get In Touch",
  summary:
    "Based in Cologne, Germany. Hired by Propstack GmbH and working as Senior Platform Engineer.",
  languages: ["German - Fluent", "English - Fluent", "Russian - Native"],
  emailParts: ["contact", "sonntag.nrw"],
  matrixUrl: "https://matrix.to/#/@luziferus:matrix.sonntag.nrw",
  mastodonUrl: "https://fosstodon.org/@luziferus",
  githubWorkUrl: "https://github.com/ffigorsonntag",
  githubPersonalUrl: "https://github.com/FallenAngel666",
};

export default contactData;
